<template>
  <div class="cookie-consent">
    <div class="consent-container" v-if="showConsent">
      <h2 class="cookie-header">We Use Cookies</h2>
      <button class="buzz-link-btn close-btn" @click="showConsent = false">&times;</button>
      <p>
        By using this site you accept our use of cookies to deliver a better user experience.
      </p>
      <button class="buzz-btn mini-btn" @click="showConsent = false">
        Understood
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showConsent: true
    }
  },
  components: {
  },
  props: {},
  watch: {},
  created () {},
  mounted () {},
  computed: {},
  methods: {
  }
}
</script>

<style scoped lang="scss">
.consent-container{
  width: 100%;
  padding: 24px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  background: #fff;
  box-shadow: 0px 0px 8px 0px rgba(81,119,155,0.4);
  z-index: 1000;
  h2.cookie-header {
    margin: 0px;
    margin-bottom: 12px;
    font-size: 16px;
    color: #2E4357;
  }
  p {
    color: #51779B;
    padding: 0px;
    margin: 0px;
    margin-bottom: 20px;
    font-size: 15px;
    line-height: 20px;
  }
}

// media queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .consent-container{
    bottom: 16px;
    left: 16px;
    max-width: 360px;
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
